import React from 'react'
import { Text, utils } from '@adc/ui-adc'
import { Maybe } from '@adc/sdk/types'
import * as blueprint from '@adc/blueprint'
import { AuctionBlueprintOnlineReactiveArgs } from '@adc/blueprint'

const formatMoney = utils.formatters.formatMoney

type EarnestMoneyDepositProps = {
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
  earnestMoneyDeposit?: Maybe<number>
  hasError?: boolean
  className?: string
}

const EarnestMoneyDeposit = ({
  className,
  listing,
  earnestMoneyDeposit,
  hasError,
}: EarnestMoneyDepositProps) => {
  if (
    !listing.__methods__.isUsingSellerLevelFees() ||
    blueprint.listing.utils.isFclOnlineAuction(listing)
  ) {
    return null
  }
  return (
    <div className={className}>
      <Text
        className='u-mr-1'
        color='gray'
        content='Earnest Money Deposit'
        data-elm-id='earnest_money_deposit_label'
        size='tiny'
      />
      <Text
        color='gray'
        content={hasError ? '–' : formatMoney(earnestMoneyDeposit, {})}
        data-elm-id='earnest_money_deposit_value'
        size='tiny'
        weight='heavy'
      />
    </div>
  )
}

export default EarnestMoneyDeposit
